import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AppSettingsContext = /*#__PURE__*/createContext(null);
export const ProvideAppSettings = ({
  rawValue,
  children
}) => /*#__PURE__*/_jsx(AppSettingsContext.Provider, {
  value: rawValue || null,
  children: children
});
export const useFrameworkAppSettings = () => useContext(AppSettingsContext);